// extracted by mini-css-extract-plugin
export var root = "SNCj";
export var rootButton = "camx";
export var rootForm = "dX2y";
export var rootHeading = "p39e";
export var rootIcon = "_4FmQ";
export var rootInfo = "iiz-";
export var rootInput = "SWNM";